import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined = loading, null = guest

  const loadMe = useCallback(async () => {
    const token = localStorage.getItem("mcevents_token");
    if (!token) { setUser(null); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
    } catch {
      localStorage.removeItem("mcevents_token");
      setUser(null);
    }
  }, []);

  useEffect(() => { loadMe(); }, [loadMe]);

  const login = (token, u) => {
    localStorage.setItem("mcevents_token", token);
    setUser(u);
  };
  const logout = () => {
    localStorage.removeItem("mcevents_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, logout, refresh: loadMe }}>
      {children}
    </AuthCtx.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthCtx);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
